module.exports = __webpack_public_path__ + "baggedmilkart.webp?3756a6ac1eb3ba9973901e70db542073";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/baggedmilkart.webp
// module id = 213
// module chunks = 0